import { SearchDocumentType, } from '../../api/api.types';
import { ClientSearchDocumentBuilder } from '../sdk.builder';
function mockImage(name) {
    return {
        name: name,
        width: 1000,
        height: 1000,
    };
}
var PAGES = [
    {
        documentType: SearchDocumentType.Pages,
        title: 'Natural Herbs',
        image: mockImage('b88f2d5da73042e2b86399ab9f21367f.jpg'),
        description: 'It’s easy to underestimate the power of plants to heal your body’s toughest ailments. Often, we go straight to over-the-counter medicines to treat our headaches, inflammation, and other syndromes. Many of us have been conditioned to depend on prescription drugs all of our lives. If you aren’t yet, it’s time to familiarize yourself with nature’s medicine: healing herbs.',
    },
    {
        documentType: SearchDocumentType.Pages,
        title: 'Fruits Covered in Chocolate',
        image: mockImage('7f0f209fce404b8a8b21ee10de5c4118.jpg'),
        description: 'Chocolate-covered fruits include blueberries, pomegranate, strawberries, oranges, dried apricots, and other candied fruits and citrus peels. dark chocolate, milk chocolate and white chocolate are used for decoration. Nuts, coconut, chocolate chips, sprinkles, and other toppings are sometimes added.',
    },
    {
        documentType: SearchDocumentType.Pages,
        title: 'Yellow Tea',
        image: mockImage('5e7d2ea14bb841b4ad61e1a43c4fdfad.jpg'),
        description: 'Yellow tea is often placed in the same category with green tea due to its light oxidation. One of the primary aims of making yellow tea is to remove the characteristic grassy smell of green tea while preserving the associated health qualities of green tea.',
    },
    {
        documentType: SearchDocumentType.Pages,
        title: 'Happy Children',
        image: mockImage('1a77bf468f24468b954aba15ddd8b1e2.png'),
        description: "Happy is a feeling of joy, pleasure, or good fortune — exactly how you'd feel if you learned that you won the lottery or got accepted into your number one choice of colleges. ... On its own, happy means an enjoyable or satisfied state of being.",
    },
    {
        documentType: SearchDocumentType.Pages,
        title: 'Greek Paradise',
        image: mockImage('3273c6e2911e44059093e6011be353a5.jpg'),
        description: 'Welcome to Greek Paradise! We are a family-owned-and-operated restaurant that serves delicious Greek, Mediterranean and American dishes',
    },
];
var PRODUCT_TITLE = "I'm a product";
var PRODUCT_DESCRIPTION = "I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item.";
var PRODUCTS = [
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_9928686dcfa740bd802821d0b6f4ac03.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$85.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_1eec973ae9eb43f4bca9876e5d90f6fa.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$20.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_119100d8c0144221b2f6733f4d205d2e.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$10.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_c6158b4d41784ae8b08337a331e1de7f.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$25.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_03155a7e79bd4cca9aaf3f0e98378100.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$7.50',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_5bc54b597d67423d8022157cef968f7b.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$15.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_5e32b6d9419343c29c68e9173b5461e0.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$85.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_ea68bd8398ac489a8e4e8b99755f96b0.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$40.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_849d96e85f044bc7ae0a47f78d9a898b.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$130.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_18ef3d9c8058444ea08059329237a1f2.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$45.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_f9b427f2017641468a0b939aa26777b5.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$95.00',
    },
    {
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        image: mockImage('a9ff3b_ed3b544c319b4fad9c222c791a997832.jpg'),
        description: PRODUCT_DESCRIPTION,
        price: '$120.00',
    },
];
var BLOGS = [
    {
        documentType: SearchDocumentType.Blogs,
        title: 'Now You Can Blog from Everywhere!',
        image: mockImage('a27d24_74a5c4593cc1454683305dbaa50c80cb~mv2_d_1880_1560_s_2.png'),
        description: 'We’ve made it quick and convenient for you to manage your blog from anywhere. In this blog post we’ll share the ways you can post to your Wix Blog. Blogging from Your Wix Blog Dashboard On the dashboard, you have everything you need to manage your blog in one place. You can create new posts, set categories and more. To head to your Dashboard, open the Wix Editor and click on Blog > Posts. Blogging from Your Published Site Did you know that you can blog right from your publish',
    },
    {
        documentType: SearchDocumentType.Blogs,
        title: 'Design a Stunning Blog',
        image: mockImage('a27d24_f116a7916f5544a79f92d43b4247a457~mv2_d_2845_1900_s_2.jpg'),
        description: "When it comes to design, the Wix blog has everything you need to create beautiful posts that will grab your reader's attention. Check out our essential design features. Choose from 8 stunning layouts Your Wix Blog comes with 8 beautiful layouts. From your blog's settings, choose the layout that’s right for you. For example, a tiled layout is popular for helping visitors discover more posts that interest them. Or, choose a classic single column layout that lets readers scroll",
    },
    {
        documentType: SearchDocumentType.Blogs,
        title: 'Grow Your Blog Community',
        image: mockImage('a27d24_e1ac8887d0e04dd5b98fb4c263af1180~mv2_d_4915_3277_s_4_2.jpg'),
        description: 'With Wix Blog, you’re not only sharing your voice with the world, you can also grow an active online community. That’s why the Wix blog comes with a built-in members area - so that readers can easily sign easily up to become members of your blog. What can members do? Members can follow each other, write and reply to comments and receive blog notifications. Each member gets their own personal profile page that they can customize. Tip: You can make any member of your blog a writer',
    },
];
var ALL_TYPES = [
    PAGES[0],
    PRODUCTS[0],
    BLOGS[0],
    PAGES[1],
    PRODUCTS[1],
    BLOGS[1],
    PAGES[2],
    PRODUCTS[2],
    BLOGS[2],
    PAGES[3],
    PRODUCTS[3],
    PAGES[4],
    PRODUCTS[4],
];
function shiftBasedOnQuery(query) {
    // shift can be the same for some queries, resulting in the same mock results. oh well
    if (!query) {
        return 0;
    }
    var shift = 0;
    var length = query.length;
    for (var i = 0; i < length; i++) {
        shift = (shift + query.charCodeAt(i)) % 100;
    }
    return shift;
}
function shiftBasedOnPagination(skip) {
    return Math.floor(skip / 10);
}
function mockResultsMapper(mock) {
    var builder = new ClientSearchDocumentBuilder();
    builder.withTitle(mock.title);
    builder.withDescription(mock.description);
    builder.withDocumentType(mock.documentType);
    builder.withImage(mock.image);
    if (mock.documentType === SearchDocumentType.Products) {
        builder.withPrice(mock.price);
    }
    return builder.getResponse();
}
function generateMockResults(mocks, config) {
    var documents = mocks.map(mockResultsMapper);
    // reversing to avoid the same search results
    // on "empty_query + page_after_first" and "some_query + page_1",
    // because in both cases we just shift/cycle/rotate mock data (`resultsShift`)
    var query = config.query === '*' ? '' : config.query;
    if (!query) {
        documents.reverse();
    }
    var resultsShift = (shiftBasedOnQuery(query) + shiftBasedOnPagination(config.skip)) %
        documents.length;
    var results = [];
    var counter = resultsShift;
    for (var i = 0; i < config.limit; i++) {
        if (counter >= documents.length) {
            counter = 0;
        }
        results.push(documents[counter]);
        counter++;
    }
    return results;
}
export function getSearchResults(config) {
    if (config.limit === 0) {
        return [];
    }
    var mocks = [];
    switch (config.documentType) {
        case SearchDocumentType.Products:
            mocks = PRODUCTS;
            break;
        case SearchDocumentType.Pages:
            mocks = PAGES;
            break;
        case SearchDocumentType.Blogs:
            mocks = BLOGS;
            break;
        default:
            mocks = ALL_TYPES;
    }
    return generateMockResults(mocks, {
        limit: config.limit,
        skip: config.skip,
        query: config.query,
    });
}
//# sourceMappingURL=searchResults.js.map